import React, { Component } from 'react'

class GenericHeader extends Component {
  render() {
    return (
      <div className="text-white" style={{ height: this.props.height, backgroundColor: '#5CC9F4' }}>
        <div className="row">
          <div className="col-md-12 text-center" style={{ marginTop: '20px' }}>
            <img width="100" src="resources/images/Monnify.white.svg" alt="Monnify" />
          </div>
        </div>
        {this.props.children}
      </div>
    )
  }
}

export default GenericHeader



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/screens/GenericHeader/index.js